// extracted by mini-css-extract-plugin
module.exports = {"container":"BookablePractitioner_container__1wYUZ","label":"BookablePractitioner_label__v3av-","bookablePractitioners":"BookablePractitioner_bookablePractitioners__2NB8P"};